<template>
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="ma-4" id="head_height">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-view-list-outline</v-icon>방문증 분실 신고 현황
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn @click="Initialize();" icon small>
          <v-icon>
            refresh
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="ml-2 mr-2"></v-divider>
      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="12" class="d-flex">
            <div class="d-flex mb-n6">
              <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectDate" @update="onDateRangeChange" cLabel="신청일자" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectLostDate" @update="onLostDateRangeChange" cLabel="분실일자" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <v-select
                v-model="editedItem.cState"
                @change="GetPassLog()"
                :items="zPassCardState"
                label="상태"
                class="mr-4 hidden-md-and-down"
                style="width:120px;"
                dense
                hide-details
              ></v-select>
              <v-text-field
                v-model="cNowSearchKeyWord"
                @keyup.enter="GetPassLog()"
                @click:append="GetPassLog()"
                append-icon="search"
                placeholder="이름 or 방문증번호"
                label="검색어"
                class="hidden-md-and-down"
                style="width:210px;"
                dense
                hide-details
                persistent-placeholder
              ></v-text-field>
            </div>
            <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectDate" @update="onDateRangeChange" cLabel="신청일자" style="width:100%" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-2">
            <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectLostDate" @update="onLostDateRangeChange" cLabel="분실일자" style="width:100%" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-1">
            <v-select
              v-model="editedItem.cState"
              @change="GetPassLog()"
              :items="zPassCardState"
              label="상태"
              class="hidden-lg-and-up"
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-3">
            <v-text-field
              v-model="cNowSearchKeyWord"
              @keyup.enter="GetPassLog()"
              @click:append="GetPassLog()"
              append-icon="search"
              placeholder="이름 or 방문증번호"
              label="검색어"
              class="hidden-lg-and-up"
              dense
              hide-details
              persistent-placeholder
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <v-card class="ma-4" v-resize="onResize">
      <v-data-table
        :headers="headers"
        :items="Records"
        v-model="selected"
        :single-select="bSingleSelect"
        @click:row="handleClick"
        @dblclick:row="handleDoubleClick(selected[0])"
        :items-per-page="15"
        item-key="cIdx"
        :height="ChangableHeight"
        fixed-header
      >
        <template v-slot:item.cCreateDateTime="{ item }">
          {{item.cCreateDateTime.substring(0,10)}}
        </template>
        <template v-slot:item.cCorpNm="{ item }">
          <div v-if="item.cLocal == 'Y'">{{item.cCorpNmKor}}</div>
          <div v-else>{{item.cCorpNmEng}}</div>
        </template>
        <template v-slot:item.cLostDateTime="{ item }">
          {{item.cLostDateTime.substring(0,10)}}
        </template>
        <template v-slot:item.cFileDirect="{ item }">
          <v-btn @click="ShowPicDialog(item)" v-if="item.cChargeCustomId == CustomInfo.CustomId && item.cCorpId == CustomInfo.CorpId && (CustomInfo.Manager == 'M' || CustomInfo.Manager == 'S') && item.cState == 'G'" small dark><v-icon small>mdi-image-plus</v-icon></v-btn>
        </template>
        <template v-slot:item.cRequest="{ item }">
          <v-btn @click="ShowReqDialog(item)" v-if="item.cCorpId == CustomInfo.CorpId && (CustomInfo.Manager == 'M' || CustomInfo.Manager == 'S') && item.cState == 'A'" small dark><v-icon small>mdi-clipboard-check-multiple</v-icon>검토</v-btn>
        </template>
        <template v-slot:item.cState="{ item }">
          <v-chip label small :color="getStateColor(item.cState)" dark>{{getState(item.cState)}}</v-chip>
        </template>
        <template v-slot:item.cEndComment="{ item }">
          <div v-if="((item.cCorpId == CustomInfo.CorpId && (CustomInfo.Manager == 'M' || CustomInfo.Manager == 'S')) || (item.cLostCustomId == CustomInfo.CustomId && CustomInfo.Manager == 'N')) && (item.cState == 'E' || item.cState == 'N')">
            <v-btn @click="ShowComment(item, item.cState)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn>
          </div>
        </template>
        <template v-slot:item.cEdit="{ item }">
          <!-- <div v-if="(item.cCorpId == CustomInfo.CorpId && CustomInfo.Manager == 'M' && (item.cState == 'R' || item.cState == 'A')) || (item.cLostCustomId == CustomInfo.CustomId && item.cState == 'A')" class="d-flex"> -->
          <!-- <div v-if="(item.cCorpId == CustomInfo.CorpId && CustomInfo.Manager == 'M' && item.cState == 'A') || (item.cLostCustomId == CustomInfo.CustomId && item.cState == 'A')" class="d-flex"> -->
            <!-- <div v-if="((item.cCorpId == CustomInfo.CorpId && (CustomInfo.Manager == 'M' || CustomInfo.Manager == 'S')) || (item.cLostCustomId == CustomInfo.CustomId)) && (item.cState == 'R' || item.cState == 'A')" class="d-flex"> -->
            <div v-if="(((item.cState == 'R' || item.cState == 'A') && item.cCorpId == CustomInfo.CorpId && (CustomInfo.Manager == 'M' || CustomInfo.Manager == 'S')) || (item.cLostCustomId == CustomInfo.CustomId && item.cState == 'A'))" class="d-flex">
              <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
              <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
            </div>
        </template>
        <template v-slot:no-data>
          <div class="black--text">{{cNoMsg}}</div>
        </template>
      </v-data-table>
    </v-card>


    <v-dialog v-model="ReqDialog" max-width="400px">
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">edit</v-icon>방문증 분실신고 사항 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="pr-4 pl-4 pb-6 pt-6 mt-2">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="selectItem.cState"
                :items="zPassReViewState"
                label="검토 여부"
                dense
                persistent-placeholder
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="mb-2"></v-divider>
              <v-btn @click="ReqDialog = false;" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
              <v-btn @click="SetReqPassLog()" dark class="ml-2"><v-icon class="mr-2">mdi-clipboard-check-multiple</v-icon>확인</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cFileDialog" v-if="cFileDialog" max-width="400px" persistent>
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-image-plus</v-icon>파일 첨부
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text class="pr-4 pl-4 pb-6 pt-6 mt-2">
          <v-row>
            <v-col cols="12">
              <v-card outlined class="ml-4 mr-4 pa-4">
                <v-img
                  :src="sNowPath"
                  contain
                  max-height="350px"
                  max-width="350px"
                ></v-img>
              </v-card>
              <v-card flat class="ml-4 mr-4 pt-4">
                <v-file-input
                  v-on:change="onSelFile(NowSelFile)"
                  v-model="NowSelFile"
                  class="mt-2"
                  accept="image/png"
                  placeholder="파일선택"
                  dense
                ></v-file-input>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12" align="right" class="pt-0 pb-0">
              <v-divider class="mb-2"></v-divider>
              <v-btn @click="CloseDialog()" text class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
              <v-btn @click="SetFileLostPass()" dark class="ml-2"><v-icon class="mr-2">save</v-icon>첨부</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <EditPassDialog ref="EditPassDialogRef" @SetLostPassLog="GetIndex" />
    <DelDialog ref="DelDialogRef" @DelPassData="DelPassData"/>
    <ResponseDialog ref="ResponseDialogRef"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import IronDate from '@/components/iron28Calendar/src/IronDate3.vue';
import Util from "../Util.js";

import EditPassDialog from "../components/EditPassDialog.vue"
import DelDialog from "../components/DelDialog.vue"
import ResponseDialog from "../components/ResponseDialog.vue"

export default {
  components: {
    IronDate,
    EditPassDialog,
    DelDialog,
    ResponseDialog,
  },
  data: () => ({
    bSingleSelect : true,
    ReqDialog : false,
    bApplyDate : false,
    cFileDialog : false,
    sNowPath : "",
    NowSelFile : null,
    loading : false,
    ChangableHeight : "",
    cNowSearchKeyWord : "",
    cNoMsg : "",
    iEditIndex : -1,
    selected : [],
    editedItem : {
      sNowSelectDate : Util.sFormatDate(Util.sBefore1Moth()) + " ~ " + Util.sFormatDate(Util.sAfter1Moth()),
      sStartDate : Util.sFormatDate(Util.sBefore1Moth()),
      sEndDate : Util.sFormatDate(Util.sAfter1Moth()),
      sNowSelectLostDate : Util.sFormatDate(Util.sBefore1Moth()) + " ~ " + Util.sFormatDate(Util.sAfter1Moth()),
      sLostStartDate : Util.sFormatDate(Util.sBefore1Moth()),
      sLostEndDate : Util.sFormatDate(Util.sAfter1Moth()),
      cState : "ALL",
    },
    selectItem : {
      cIdx : "",
      cState : "",
      cLostCustomNm : "",
    },
    FileItem : {
      cLostCustomNm : "",
      cFileId : "",
      cPath : "",
      cIdx : "",
    },
    defaultFileItem : {
      cLostCustomNm : "",
      cFileId : "",
      cPath : "",
      cIdx : "",
    },
    Records : [],
    headers : [
      { text: 'NO', align: 'center', value: 'sNum',width : "10"},
      { text: '신청일자', value: 'cCreateDateTime',width: "120",align: 'center'},
      { text: '출입자명', value: 'cLostCustomNm',align: 'center'},
      { text: '소속 업체명', value: 'cCorpNm',align: 'center'},
      { text: '전화번호', value: 'cTel',align: 'center'},
      { text: '방문증번호', value: 'cPassNm',align: 'center'},
      { text: '분실일자', value: 'cLostDateTime',align: 'center'},
      { text: '증빙서류첨부', value: 'cFileDirect', align: 'center'},
      { text: '검토', value: 'cRequest', align: 'center'},
      { text: '상태', value: 'cState', align: 'center'},
      { text: '의견', value: 'cEndComment',width : 60, align : "center"},
      { text: '작업', value: 'cEdit',width : 80, align: 'center'},
    ],
  }),

  computed: {
    ...mapState(["CustomInfo","zPassCardState","zPassReViewState","FMaxSize3","zFileType"]),
  },

  created() {
  },

  mounted() {
    this.Initialize();
  },

  methods : {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },

    Initialize(){
      this.bApplyDate = true;
      this.DataInit();
      this.GetPassLog();
    },

    // 데이터 초기화 하기
    DataInit () {
      this.cNowSearchKeyWord = "";
      this.editedItem.sNowSelectDate =  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " + Util.sFormatDate(Util.sAfter1Moth());
      this.editedItem.sStartDate = Util.sFormatDate(Util.sBefore1Moth());
      this.editedItem.sEndDate = Util.sFormatDate(Util.sAfter1Moth());
      this.editedItem.sNowSelectLostDate =  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " + Util.sFormatDate(Util.sAfter1Moth());
      this.editedItem.sLostStartDate = Util.sFormatDate(Util.sBefore1Moth());
      this.editedItem.sLostEndDate = Util.sFormatDate(Util.sAfter1Moth());
      this.editedItem.cState = "ALL";
    },

    ShowDelDialog(item){
      this.$refs.DelDialogRef.ShowDialog("Pass",item,this.Records.indexOf(item));
    },
    
    DelPassData(index,item){
      this.DelPassLog(index,item)
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.editedItem.sStartDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.sEndDate = Util.sFormatDate(daterange.endDate);
      this.editedItem.sNowSelectDate = this.editedItem.sStartDate + " ~ " + this.editedItem.sEndDate;
      this.GetPassLog();
    },

    onLostDateRangeChange(daterange){
      this.editedItem.sLostStartDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.sLostEndDate = Util.sFormatDate(daterange.endDate);
      this.editedItem.sNowSelectLostDate = this.editedItem.sLostStartDate + " ~ " + this.editedItem.sLostEndDate;
      this.GetPassLog();
    },

    GetIndex(item,index){
      this.Records[index].cIdx = item.cIdx
      this.Records[index].cState = item.cState
      this.Records[index].cLostCustomId = item.cLostCustomId
      this.Records[index].cLostCustomNm = item.cLostCustomNm
      this.Records[index].cLostDateTime = item.cLostDateTime
      this.Records[index].cPassId = item.cPassId
      this.Records[index].cPassNm = item.cPassNm
      this.Records[index].cTel = item.cTel
      this.Records[index].cLocal = item.cLocal
      this.Records[index].cCorpNmEng = item.cCorpNmEng
      this.Records[index].cCorpNmKor = item.cCorpNmKor
      this.Records[index].cPassMappingId = item.cPassMappingId
    },

    getStateColor(cState){
      return this.zPassCardState.find((e) => {return e.value == cState})?.color
    },

    getState(cState){
      return this.zPassCardState.find((e) => {return e.value == cState})?.text
    },

    handleClick(value) {
      this.selected = [value];
    },

    handleDoubleClick(item) {
      if (this.CustomInfo.Manager == "M" || this.CustomInfo.Manager == "S") {
        if (item.cCorpId != this.CustomInfo.CorpId || !(item.cState == "R" || item.cState == 'A')) return
      } else {
        if (item.cLostCustomId != this.CustomInfo.CustomId || item.cState != 'A') return
      }

      if (this.selected.length > 0 || item.cIdx != undefined){
        this.OpenDialog(item)
      }
    },

    // 업체정보 가져오기
    GetPassLogItem(item){
      var posData = {
        Idx : item.cIdx,
      };
      return new Promise((resolve) => (
        axios
        .post(process.env.VUE_APP_UIL_API + "GetPassLogItem", posData, {
          headers: {
            "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          resolve(res);
        })
        .catch(err => {
          resolve(err);
        })
      ))
    },

    async OpenDialog(item) {
      let EditIndex = this.Records.indexOf(item);
      let res = await this.GetPassLogItem(item);

      if (res.data.ResultCd == "00") {
        this.$refs.EditPassDialogRef.ShowDialog(item,EditIndex,res.data.Result);
      } else {
        EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
      }
    },

    ShowComment(oitem,StateNm) {
      this.$refs.ResponseDialogRef.ShowDialog(oitem,this.getState(StateNm),false)
    },

    ShowNoResultMsg() {
      this.cNoMsg = ""

      setTimeout(() => {
        this.cNoMsg = "검색된 방문자가 없습니다."
      }, 300);
    },

    // 방문증 분실신고 현황 가져오기
    GetPassLog(){
      this.Records = [];

      var posData = {
        Manager : this.CustomInfo.Manager,
        CorpId : this.CustomInfo.CorpId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        StartDate : this.editedItem.sStartDate,
        EndDate : this.editedItem.sEndDate,
        LostStartDateTime : this.editedItem.sLostStartDate,
        LostEndDateTime : this.editedItem.sLostEndDate,
        State : this.editedItem.cState,
        NowSearchKeyWord : this.cNowSearchKeyWord,
        ReqState : "O",
        ApplyDate : this.bApplyDate,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "GetPassLog", posData, {
          headers: {
            Authorization: this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length > 0) {
              for (let i = 0; i < res.data.Result.length; i ++) {
                res.data.Result[i].sNum = i + 1
              }
            } else {
              this.ShowNoResultMsg();
            }

            this.Records = res.data.Result;
            this.bApplyDate = false
          } else if (res.data.ResultCd == BasicInfo.ERROR_CODE_CHECK_RIGHT_CUSTOM) {
            EventBus.$emit("onShowMsgBox", "정보 조회가 불가 합니다.","소속업체 또는 관리자 권한이 변경되었을 수 있습니다.\n새로고침 버튼을 눌러 주세요.");
            this.ShowNoResultMsg();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    ShowPicDialog(item) {
      this.iEditIndex = this.Records.indexOf(item)
      this.FileItem.cIdx = item.cIdx
      this.FileItem.cFileId = item.cFileId
      this.cFileDialog = true;
      this.FileItem.cPath = item.cPath
      this.FileItem.cLostCustomNm = item.cLostCustomNm
      this.sNowPath = process.env.VUE_APP_FILE_API + item.cPath
    },

    CloseDialog() {
      this.cFileDialog = false;
      this.NowSelFile = null
      this.FileItem = Object.assign({},this.defaultFileItem);
    },

    async SetFileLostPass() {
      this.loading = true;

      if (this.NowSelFile != null) {
        var res = await this.bSendSvrFile();
        if (res.data.ResultCd == "00") {
          this.FileItem.cFileId = res.data.FileId;
          this.FileItem.cPath = res.data.Path;
        } else {
          this.loading = false;
          EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!");
          return;
        }
      }

      // include로 포함 시 에러 메세지 표출 OR replace로 바꿔서 데이터 넣기
      var posData = {
        Path : this.FileItem.cPath,
        FileId : this.FileItem.cFileId,
        Idx : this.FileItem.cIdx,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        Manager : this.CustomInfo.Manager,
        CorpNm : Util.ChangeCorpNm3Data(this.CustomInfo.Local,this.CustomInfo.CorpNmKor,this.CustomInfo.CorpNmEng),
        // ChargeCustomNm : this.CustomInfo.CustomNm,
        LostCustomNm : this.FileItem.cLostCustomNm,
        CorpId : this.CustomInfo.CorpId,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetFileLostPass", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.cFileDialog = false;
            this.Records[this.iEditIndex].cPath = res.data.Result[0].cPath
            EventBus.$emit("onShowMsg",false, "파일 첨부가 완료되었습니다.");
          } else if (res.data.ResultCd === "02") {
            EventBus.$emit("onShowMsgBox", "신청 하신 사항의 상태가 변경 되었습니다.", res.data.Msg);
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox", "신청 하신 사항의 검토 관리자가 변경 되었습니다.", "관리자에게 문의 바랍니다.");
          } else if (res.data.ResultCd === "06") {
            EventBus.$emit("onShowMsgBox","관리자 권한이 변경 되었습니다.",  "화면을 다시 접속하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    // 파일 선택시 정보 불러오기
    onSelFile(NowSelFile) {
      let bFileType = false

      if (NowSelFile != null) {
        if (NowSelFile.size > this.FMaxSize3) {
          this.sNowPath = ""
          setTimeout(() => {
            this.NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
        this.sNowPath = ""
      }

      if (!bFileType) {
        setTimeout(() => {
          this.NowSelFile = null;
        }, 300);
        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      const reader = new FileReader

      reader.onload = e => {
        var imageData = e.target.result;
        this.sNowPath = imageData;
      }
      try {
        reader.readAsDataURL(NowSelFile)
      } catch (error) {
        this.sNowPath = process.env.VUE_APP_FILE_API + this.FileItem.cPath
        EventBus.$emit("onFileBus", true,""+error);
        // EventBus.$emit("onShowMsg", true,""+error);
      }
    },

    // 파일 저장하기
    bSendSvrFile(){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = this.NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(this.NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadfile', this.NowSelFile);
      return new Promise((resolve) => (
        axios.post(process.env.VUE_APP_UIL_API + "UploadFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+this.NowSelFile.type+"&Size="+this.NowSelFile.size+"&FileTypeId="+sFileTypeId+"&SiteId="+this.$store.state.CustomInfo.SiteId,
                formData,
                {
                headers: {
                  // "Authorization": this.CustomInfo.Token,
                  'Content-Type': 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              this.loading = false;
              resolve(null);
              EventBus.$emit("onShowMsg",true, "File Send Error-Network Error!" + err)
          })
      ));
    },

    ShowReqDialog(item){
      this.iEditIndex = this.Records.indexOf(item)
      this.ReqDialog = true;
      this.selectItem.cIdx = item.cIdx
      this.selectItem.cState = item.cState
      this.selectItem.cLostCustomNm = item.cLostCustomNm
    },

    // 방문증 검토상태 번경하기
    SetReqPassLog(){
      var posData = {
        Idx : this.selectItem.cIdx,
        State : this.selectItem.cState,
        CorpId : this.CustomInfo.CorpId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        // ChargeCustomNm : this.CustomInfo.CustomNm,
        LostCustomNm : this.selectItem.cLostCustomNm,
        Manager : this.CustomInfo.Manager,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetReqPassLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd == "55") { EventBus.$emit("onDelCustomInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.ReqDialog = false
            this.Records[this.iEditIndex].cState = this.selectItem.cState
            EventBus.$emit("onShowMsg",false, "검토를 성공적으로 마쳤습니다.");
          } else if (res.data.ResultCd == "02"){
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else if (res.data.ResultCd == "04"){
            EventBus.$emit("onShowMsgBox","관리자 권한이 해지 되었습니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else if (res.data.ResultCd == "06"){
            EventBus.$emit("onShowMsgBox","아이디가 삭제 되었습니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    DelPassLog(index,item){
      var posData = {
        CustomId : this.CustomInfo.CustomId,
        SiteId : this.CustomInfo.SiteId,
        CorpId : this.CustomInfo.CorpId,
        Manager : this.CustomInfo.Manager,
        Idx : item.cIdx,
        LostCustomId : this.Records[index].cLostCustomId,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "DelPassLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.Records.splice(index, 1);
            for (let i = 0; i < this.Records.length;i ++){
              this.Records[i].sNum = i+1
            }
            EventBus.$emit("onShowMsg",false,  "삭제되었습니다.");
          } else if (res.data.ResultCd === "02") {
            EventBus.$emit("onShowMsgBox","관리자 권한이 변경 되었습니다.",  "화면을 다시 접속하여 주세요.");
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox","담당자가 접수한 사항 입니다.", "초기화 버튼을 눌러서 상태 항목을 확인하여 주세요.");
          } else if (res.data.ResultCd === "06") {
            EventBus.$emit("onShowMsgBox","협력업체 관리자가 검토를 마친 사항입니다.", "초기화 버튼을 눌러서 상태 항목을 확인하여 주세요.");
          } else {
            // 관리자가 검토를 마친 사항입니다. 초기화 버튼을 눌러서 상태를 확인해 주세요."
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },
  }
}
</script>